import { VStack } from '@chakra-ui/layout'
import { Spinner, Text } from '@chakra-ui/react'
import React from 'react'

const Loader = ({ loading, text }: { loading: boolean; text: string }) => {
  return (
    <VStack
      display={loading ? 'flex' : 'none'}
      zIndex="1033000"
      bg="rgba(0, 0, 0, 0.9)"
      inset="0"
      w="100wh"
      h="100vh"
      justify="center"
      align="center"
      position="fixed">
      <Spinner size="xl" />
      <Text mt="8" color="white">
        {text}
      </Text>
    </VStack>
  )
}

export { Loader }
